import { lazy as originalLazy } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

const getModuleDetails = moduleImport => ({
    moduleId: /"(.*)"/.exec(moduleImport?.toString())?.[1] || '',
    importFunction: moduleImport?.toString(),
});

const customLazy = moduleImport => originalLazy(
    async () => {
        try {
            const module = await moduleImport();

            if (module === undefined) {
                datadogLogs.logger.error('Module fetched, but it\'s undefined', getModuleDetails(moduleImport));
            }

            return module;
        } catch (error) {
            datadogLogs.logger.error(error.message, getModuleDetails(moduleImport), error);
            throw error;
        }
    }
);

export default customLazy;
